import { useEffect } from "react";
import cx from "classnames";

import useLayoutStore from "components/Layout/stores/useLayoutStore";

import Box, { BoxProps } from "../Box";
import styles from "./styles.module.css";

const FullScreenModalWrapper = ({
  children,
  direction = "column",
  className,
  ...restProps
}: BoxProps) => {
  const setIsFullScreenModalOpen = useLayoutStore((state) => state.setIsFullScreenModalOpen);

  useEffect(() => {
    setIsFullScreenModalOpen(true);
    return () => setIsFullScreenModalOpen(false);
  }, [setIsFullScreenModalOpen]);

  return (
    <Box
      // It is needed to detect element when drawer open
      data-fullscreen-modal-wrapper
      direction={direction}
      className={cx(styles.wrapper, className)}
      {...restProps}
    >
      {children}
    </Box>
  );
};

FullScreenModalWrapper.displayName = "DS.FullScreenModal.Wrapper";

export default FullScreenModalWrapper;
